import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import logo from "../../images/Maxicus_logo.png";
import { endSessionActivityTracking } from "../../services/sessionActivityTracker";

const Logout = () => {
  const history = useHistory();

  useEffect(() => {
    endSessionActivityTracking().finally(() => {
      localStorage.clear();
    });
  }, []);

  return (
    <div className="logout-container" style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f8f9fc',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
    }}>
      <div style={{ marginBottom: '30px' }}>
        <img src={logo} alt="Maxicus Logo" style={{ height: '50px' }} />
      </div>

      <div style={{
        background: '#fff',
        padding: '50px 40px',
        borderRadius: '16px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
        maxWidth: '450px',
        width: '90%',
        textAlign: 'center',
        border: '1px solid #edf2f7'
      }}>
        <div style={{ marginBottom: '24px' }}>
          <CheckCircleFilled style={{ fontSize: '64px', color: '#52c41a' }} />
        </div>

        <h2 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#19466b',
          marginBottom: '16px'
        }}>
          Successfully Logged Out
        </h2>

        <p style={{
          fontSize: '16px',
          color: '#718096',
          lineHeight: '1.6',
          marginBottom: '32px'
        }}>
          You have been safely signed out of the <strong>Digital Hiring</strong> application. Thank you for your work today.
        </p>

        <Button
          type="primary"
          size="large"
          style={{
            background: '#f39200',
            borderColor: '#f39200',
            height: '48px',
            padding: '0 40px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            boxShadow: '0 4px 14px rgba(243, 146, 0, 0.3)'
          }}
          onClick={() => history.push("/login")}
        >
          Log In Again
        </Button>
      </div>

      <div style={{ marginTop: '40px', color: '#a0aec0', fontSize: '14px' }}>
        &copy; {new Date().getFullYear()} Maxicus. All rights reserved.
      </div>
    </div>
  );
};

export default Logout;
